import Immutable, { Record, List } from 'immutable';
import CategoryItem from './CategoryItem';

const CategoryRecord = Record({
  lessonNumber: undefined,
  cicCategoryId: undefined,
  cicCategoryName: undefined,
  orderingSequence: undefined,
  cicCategoryItems: new List(),
});

class Category extends CategoryRecord {}

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'cicCategoryItems':
      return [key, new List(val.map(CategoryItem.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

Category.create = (data) =>
  new Category(data).mapEntries(reviver);

export default Category;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Category/model.js